import { useAuthStore } from '@/stores/AuthStore'
import { env } from '@/config/env'
const { VITE_API_V1_MAIN_DOMAIN } = env;

/**
 * Checks if the current user is an admin
 * @param to the next route
 * @param from the previous route
 * @param next vue router next function
 * @returns whether a user is an admin
 */
export const checkAdminRights = (to: any, from: any, next: any) => {
  const authStore = useAuthStore();

  // check if the user is authenticated
  if(authStore.user) {
    // If user is admin and hostname is the public/main hostname
    if (authStore.user.is_admin && window.location.hostname == VITE_API_V1_MAIN_DOMAIN) {
      next()
      return true
    }
  }

  next({path: '/'})
}

/**
 * Checks the hostname compared with admin status
 * @param to the next route
 * @param from the previous route
 * @param next vue router next function
 * @returns whether a user may view a page
 */
export const checkHostname = (to: any, from: any, next: any) => {
  const authStore = useAuthStore();

  // Check if the user is authenticated
  // and hostname is not public/main hostname
  if(authStore.user && window.location.hostname == VITE_API_V1_MAIN_DOMAIN) {
    // If user is admin send to /superuser endpoint
    if (authStore.user.is_admin) {
      next({path: '/superuser'})
      return true
    }
    next()
    return false
  }

  next()
  return true
}
